import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { FC, useCallback, useState } from "react";
import { toast } from "react-toastify";

import { WithChildren } from "utils/types";

const ReactQueryProvider: FC<WithChildren> = ({ children }) => {
  const handleError = useCallback((error: any) => {
    toast.error(error?.data?.message || "Something went wrong");
  }, []);

  const handleSuccess = useCallback((response: any) => {
    toast.success(response?.message || "Success");
  }, []);

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            onError: handleError,
          },
          mutations: {
            onError: handleError,
            onSuccess: handleSuccess,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.NODE_ENV === "development" && (
        <ReactQueryDevtools position="bottom-right" />
      )}
    </QueryClientProvider>
  );
};

export default ReactQueryProvider;
